<div class="main-container">
  <div class="page-header">
    <div class="routing-buttons">
      <div
        class="action-button back-button"
        (click)="navigateBack()"
        tabindex="0"
        (keydown.enter)="navigateBack()"
      >
        <mat-icon class="icon back-icon">arrow_back</mat-icon>
      </div>
      <div
        class="action-button reload-button"
        (click)="ngOnInit()"
        tabindex="0"
        (keydown.enter)="ngOnInit()"
      >
        <mat-icon class="icon reload-icon">refresh</mat-icon>
      </div>
      <span class="page-title">Government Server</span>
    </div>

    <div class="button-group">
      @if (canViewFirmwareMaster) {
        <button class="primary-button" (click)="redirect('firmware-master')">
          Firmware Master
          <mat-icon class="btn-icon">open_in_new</mat-icon>
        </button>
      }
      @if (canCreateGovServers) {
        <button
          class="primary-button"
          [disabled]="!canCreateGovServers"
          (click)="redirect('govt-servers-add')"
        >
          Add Government Server
          <mat-icon class="btn-icon">open_in_new</mat-icon>
        </button>
      }
    </div>
  </div>

  @if (canViewGovServers) {
    <div class="component-container">
      <!-- Component Header Section -->
      <div class="component-header">
        <h6 class="component-title">Government Servers List</h6>
        <div class="component-actions">
          <!-- <button class="primary-button">
          Download <mat-icon class="btn-icon">download</mat-icon>
        </button> -->
          <app-common-search
            (searchSubmit)="onSearchInputChange($event)"
          ></app-common-search>
        </div>
      </div>

      <!-- Separator between Header and Body -->
      <div class="component-separator"></div>

      <!-- Component Body Section -->
      <div class="component-body">
        <form [formGroup]="govtServersForm" novalidate>
          <table>
            <thead>
              <tr>
                <th>State Name</th>
                <th>State Code</th>
                <th>State Enable OTA Command</th>
                <th>State Primary IP:PORT</th>
                <th>State Secondary IP:PORT</th>
                <th>Action</th>
              </tr>
            </thead>
            @if (displayedItems.length > 0) {
              <tbody>
                @for (item of displayedItems; track item) {
                  <tr>
                    <td>{{ item.state }}</td>
                    <td>{{ item.stateCode }}</td>
                    <td>
                      {{
                        item.stateEnableOTACmd ? item.stateEnableOTACmd : '--'
                      }}
                    </td>
                    <td>
                      {{ item.govtIp1 ? item.govtIp1 : '--' }}:{{
                        item.port1 ? item.port1 : '--'
                      }}
                    </td>
                    <td>
                      {{ item.govtIp2 ? item.govtIp2 : '--' }}:{{
                        item.port2 ? item.port2 : '--'
                      }}
                    </td>
                    <td>
                      <div class="action-buttons">
                        @if (canUpdateGovServers) {
                          <button
                            class="primary-button view-button"
                            (click)="viewGSDetails(item.id)"
                          >
                            <mat-icon class="btn-icon">visibility</mat-icon>
                          </button>
                        }
                        @if (canDeleteGovServers) {
                          <button
                            class="primary-button delete-button"
                            (click)="deleteGovtServer(item.id)"
                          >
                            <mat-icon class="btn-icon">delete</mat-icon>
                          </button>
                        }
                      </div>
                    </td>
                  </tr>
                }
              </tbody>
            }
            @if (displayedItems.length === 0) {
              <tbody>
                <tr>
                  <td colspan="12">
                    <img
                      loading="lazy"
                      class="no-data-img"
                      src="../../assets/dataNotFound.jpg"
                      alt="No Data Found"
                    />
                  </td>
                </tr>
              </tbody>
            }
          </table>
        </form>
      </div>

      <div class="component-separator"></div>
      <!-- Component Footer Section (Optional) -->
      <div class="component-footer">
        @if (displayedItems.length > 0) {
          <app-common-component-pagination
            [totalItems]="totalItems"
            [pageSize]="pageSize"
            [currentPage]="currentPage"
            [totalPages]="totalPages"
            (pageChange)="onPageChange($event)"
            (sizeChange)="onSizeChange($event)"
          >
          </app-common-component-pagination>
        }
      </div>
    </div>
  }
</div>
